import { toast } from 'react-toastify';
import { useQuery } from '@tanstack/react-query';
import { materialAndEquipmentService } from '@services/material&Equipment';
import { useTranslation } from '@hooks/useTranslation';

export const useGetMaterialAndEquipment: any = (projectId?: string | null) => {
  const tActionMessages = useTranslation('actionMessages');
  return useQuery({
    queryKey: ['materials', 'equipments'],
    queryFn: async () => {
      try {
        if (!projectId) return [];
        const data =
          await materialAndEquipmentService.getMaterialsAndEquipments(
            projectId as string,
          );
        return data;
      } catch (error) {
        toast.error(tActionMessages.errorFetchingMaterialsAndEquipment);
      }
    },
  });
};
